import appConfig from "@core/config";
import type { MediaItem } from "@core/typesV2";
import { NavigateFunction } from "react-router-dom";

import AxiosServiceV2, { TokenHandlers } from "./axiosServiceV2";

export default class MediaLibraryService extends AxiosServiceV2 {
  constructor(tokenHandlers: TokenHandlers, navigateTo: NavigateFunction) {
    super(
      `${appConfig.LEARNING_BASE_URL}/api/v1/lcms/media/`,
      tokenHandlers,
      navigateTo,
    );
  }

  getUrls(mediaIds: string[]) {
    return this.post<Record<string, string>, string[]>(
      "items/urls?includeSasToken=true&includeDeleted=true",
      mediaIds,
      undefined,
      { skipNavigateIfError: true },
    );
  }

  getMediaItemById(id: string) {
    return this.get<MediaItem>(`items/${id}?includeDeletedFiles=true`);
  }
}
